export const Color = {
  White: "#ffffff",
  Primary: {
    50: "#F8FAFE",
    100: "#F2F5F9",
    200: "#DBE7F7",
    300: "#C5D5ED",
    400: "#8D9CB7",
    500: "#57657D",
    600: "#212E44",
    700: "#131E30",
    800: "#0D1626",
    900: "#070E1A",
    950: "#050A14",
  },
  Gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
    950: "#0c0e12",
  },
  Emerald: {
    50: "#ecfdf5",
    100: "#d1fae5",
    200: "#a7f3d0",
    300: "#6ee7b7",
    400: "#34d399",
    500: "#10b981",
    600: "#059669",
    700: "#047857",
    800: "#065f46",
    900: "#064e3b",
    950: "#16352f",
  },
  Green: {
    50: "#f0fdf4",
    100: "#dcfce7",
    200: "#bbf7d0",
    300: "#86efac",
    400: "#4ade80",
    500: "#22c55e",
    600: "#16a34a",
    700: "#15803d",
    800: "#166534",
    900: "#14532d",
    950: "#052e16",
  },
  Rose: {
    50: "#fdf2f2",
    100: "#fde8e8",
    200: "#fbd5d5",
    300: "#f8b4b4",
    400: "#fb7185",
    500: "#f43f5e",
    600: "#e11d48",
    700: "#be123c",
    800: "#9f1239",
    900: "#881337",
    950: "#5a0d27",
  },
  Indigo: {
    50: "#f5f7ff",
    100: "#e4e7f5",
    200: "#ccd2eb",
    300: "#abb8f0",
    400: "#818cf8",
    500: "#6366f1",
    600: "#4f46e5",
    700: "#4338ca",
    800: "#3730a3",
    900: "#312e81",
    950: "#1e1e3f",
  },
  Orange: {
    50: "#fff7ed",
    100: "#ffedd5",
    200: "#fed7aa",
    300: "#fdba74",
    400: "#fb923c",
    500: "#f97316",
    600: "#ea580c",
    700: "#c2410c",
    800: "#9a3412",
    900: "#7c2d12",
    950: "#4d1e07",
  },
  Blue: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a",
    950: "#1e3a8a",
  },
  Yellow: {
    200: "#fef08a",
    300: "#fde047",
    400: "#facc15",
    500: "#eab308",
    600: "#ca8a04",
    700: "#a16207",
    800: "#854d0e",
  },
  Amber: {
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    500: "#f59e0b",
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
  },
  Teal: {
    200: "#99f6e4",
    300: "#5eead4",
    400: "#2dd4bf",
    500: "#14b8a6",
    600: "#0d9488",
    700: "#0f766e",
    800: "#115e59",
  },
};

export const blueGradient = [Color.Indigo[400], Color.Indigo[500]];
export const redGradient = [Color.Rose[600], Color.Rose[700]];
export const redFadedGradient = ["#802441", "#802441"];
export const greenGradient = [Color.Green[400], Color.Green[500]];
